import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Tags, Package, Palette } from 'lucide-react';
import { useInventory } from '../context/InventoryContext';
import CategoryCard from '../components/categories/CategoryCard';
import Button from '../components/ui/Button';

const CategoriesPage: React.FC = () => {
  const { categories, deleteCategory } = useInventory();
  
  const handleDeleteCategory = (id: string) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      deleteCategory(id);
    }
  };
  
  return (
    <div className="space-y-6">
      {/* Hero Banner */}
      <div className="overflow-hidden rounded-lg">
        <div className="relative">
          <img
            src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="Organized filing system with color-coded categories and labels"
            className="w-full h-64 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30 flex items-center">
            <div className="px-8 text-white">
              <h1 className="text-3xl font-bold mb-2">Categories</h1>
              <p className="text-lg opacity-90">
                Organize and manage your product categories efficiently
              </p>
              <div className="mt-4 flex items-center space-x-6 text-sm">
                <div className="flex items-center">
                  <Tags className="h-4 w-4 mr-2" />
                  <span>{categories.length} Total Categories</span>
                </div>
                <div className="flex items-center">
                  <Palette className="h-4 w-4 mr-2" />
                  <span>Color-coded Organization</span>
                </div>
                <div className="flex items-center">
                  <Package className="h-4 w-4 mr-2" />
                  <span>Product Classification</span>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute top-4 right-4">
            <Link to="/categories/new">
              <Button>
                <Plus className="h-4 w-4 mr-2" />
                Add Category
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {categories.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 mb-4">No categories found</p>
          <Link to="/categories/new">
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Add Your First Category
            </Button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {categories.map(category => (
            <CategoryCard
              key={category.id}
              category={category}
              onDelete={handleDeleteCategory}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoriesPage;